import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  actions: {
    '& .MuiButton-root': {
      width: '100%'
    }
  }
});
export default useStyles;